import { account } from '../core/account.js';
import { i18n, t } from '../core/i18n.js';
import { notify } from '../core/notify.js';
import { escapeHtml, formatDate } from '../core/utils.js';

/* Dispositivos: sesiones abiertas con la cuenta Filoteca (móvil, PC, TV emparejada…).
   Se pueden renombrar y cerrar; cerrar la sesión actual equivale a salir de la cuenta. */

let seq = 0;

function iconFor(label) {
    const l = String(label || '').toLowerCase();
    if (/tv|televis/.test(l)) return 'tv';
    if (/android|iphone|ipad|ios|móvil|movil|phone/.test(l)) return 'smartphone';
    if (/escritorio|windows|macos|linux|chromeos|desktop/.test(l)) return 'computer';
    return 'devices';
}

function row(s) {
    return `<div class="admin-user devices-row" data-id="${escapeHtml(s.id)}">
        <span class="admin-avatar mi">${iconFor(s.device)}</span>
        <div class="admin-user-body">
            <div class="admin-user-name">${escapeHtml(s.device || t('settings.platform'))}${s.current ? ` <span class="tag">${t('devices.thisDevice')}</span>` : ''}</div>
            <div class="admin-user-sub">${t('devices.lastSeen', { date: formatDate(s.lastSeen, i18n.lang) })}</div>
        </div>
        <button type="button" class="btn btn-icon" data-rename aria-label="${t('devices.rename')}"><span class="mi">edit</span></button>
        <button type="button" class="btn btn-icon" data-remove aria-label="${t('devices.remove')}"><span class="mi">logout</span></button>
    </div>`;
}

export function openDevices() {
    const app = window.app;
    const id = 'devices-' + (++seq) + '-' + Date.now().toString(36);
    const html = `<div class="popup catpick-popup admin-popup" id="${id}">
        <div class="view">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('devices.title')}</div>
                    <div class="right"><a href="#" class="link popup-close" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content">
                    <p class="px small muted">${t('settings.devicesSub')}</p>
                    <div class="field-error" data-error hidden></div>
                    <div class="admin-list" data-list><div class="spinner"></div></div>
                </div>
            </div>
        </div>
    </div>`;

    let sessions = [];
    const popup = app.popup.create({
        content: html,
        on: {
            open(p) {
                const el = p.el;
                const list = el.querySelector('[data-list]');
                const errorEl = el.querySelector('[data-error]');
                const showError = (msg) => { errorEl.textContent = msg; errorEl.hidden = !msg; };
                const paint = () => { list.innerHTML = sessions.length ? sessions.map(row).join('') : `<div class="empty"><span class="mi">devices</span><p>${t('devices.empty')}</p></div>`; };
                const load = async () => {
                    try {
                        sessions = await account.listSessions();
                        paint();
                    } catch (e) {
                        list.innerHTML = '';
                        showError(t('common.errorNetwork'));
                    }
                };
                load();

                list.addEventListener('click', async (e) => {
                    const rowEl = e.target.closest('[data-id]');
                    if (!rowEl) return;
                    const sid = rowEl.getAttribute('data-id');
                    const s = sessions.find((x) => x.id === sid);
                    if (!s) return;
                    if (e.target.closest('[data-rename]')) {
                        e.preventDefault();
                        app.dialog.prompt(t('devices.renamePrompt'), t('devices.rename'), async (value) => {
                            const name = String(value || '').trim();
                            if (!name) return;
                            try {
                                await account.renameSession(sid, name);
                                await load();
                            } catch (err) {
                                showError(t('common.errorNetwork'));
                            }
                        }, null, s.device);
                        return;
                    }
                    if (e.target.closest('[data-remove]')) {
                        e.preventDefault();
                        app.dialog.confirm(t('devices.removeConfirm', { name: s.device || t('settings.platform') }), t('devices.remove'), async () => {
                            try {
                                if (s.current) {
                                    popup.close();
                                    await window.IPTV.actions.signOut();
                                    return;
                                }
                                await account.revokeSession(sid);
                                notify.toast(t('devices.removed'), { icon: 'check' });
                                await load();
                            } catch (err) {
                                showError(t('common.errorNetwork'));
                            }
                        });
                    }
                });
            },
            closed(p) {
                p.destroy();
                const el = document.getElementById(id);
                if (el) el.remove();
            }
        }
    });
    popup.open();
}
